import { z, ZodType } from 'zod';
import { Validation } from '@mews/framework';
import {
    AccountingExportIntegrationAccountingConfiguration,
    AccountingExportIntegrationExportTypes,
    AccountingExportIntegrationTaxAccountMapping,
} from '@mews-commander/data-access';
import { FieldNames } from './fieldNames';

const taxAccountMappingSchema = z.object({
    taxCode: z.string().min(1).default(''),
    externalCode: z.string().min(1).default(''),
    exportType: z.nativeEnum(AccountingExportIntegrationExportTypes).nullable().default(null),
}) satisfies ZodType<AccountingExportIntegrationTaxAccountMapping>;

export const accountingExportConfigurationSchema = z.object({
    [FieldNames.transferAccountCode]: Validation.String.Required.default(''),
    [FieldNames.folioBalanceAccountCode]: Validation.String.Required.default(''),
    [FieldNames.depositAccountCode]: Validation.String.Required.default(''),
    [FieldNames.accountReceivableAccountCode]: Validation.String.Required.default(''),
    [FieldNames.companyCode]: z.string().nullable().optional().default(''),
    [FieldNames.distinctionTransaction]: z.coerce.number().int().min(1).max(2).nullable().optional().default(2),
    [FieldNames.accountReceivableExportType]: z
        .nativeEnum(AccountingExportIntegrationExportTypes)
        .nullable()
        .default(null)
        .optional(),
    [FieldNames.taxAccountMappings]: taxAccountMappingSchema.array().default([]).optional(),
    [FieldNames.revenueFallbackAccountCode]: z.string().optional().default(''),
    [FieldNames.paymentFallbackAccountCode]: z.string().optional().default(''),
    [FieldNames.outletBillsFallbackAccountCode]: z.string().optional().default(''),
    [FieldNames.otherFallbackAccountCode]: z.string().optional().default(''),
}) satisfies ZodType<AccountingExportIntegrationAccountingConfiguration>;

export type AccountingExportConfigurationSchema = z.infer<ZodType<AccountingExportIntegrationAccountingConfiguration>>;
